import React from "react";
import { Button } from "antd";
import type { ButtonProps } from "antd";

export interface ActionButtonProps {
  type?: ButtonProps["type"];
  onClick?: () => void;
  text: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  type = "default",
  onClick,
  text,
  icon,
  disabled = false,
  loading = false
}) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      icon={icon}
      disabled={disabled}
      loading={loading}
    >
      {text}
    </Button>
  );
};

export default ActionButton;
